export default {
  text: '#0c3450',
  primary: '#ada89d',
  secondary: '#a59167',
  background: 'white',
  backgroundSecondary: '#202020',
  light: '#FFF',
  dark: '#020303'
}
